/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Unknownlp3Inputs */

const en_coinvestments_senddrafts_unknownlp3 = /** @type {(inputs: Coinvestments_Senddrafts_Unknownlp3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown investor`)
};

/**
* | output |
* | --- |
* | "Unknown investor" |
*
* @param {Coinvestments_Senddrafts_Unknownlp3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_unknownlp3 = /** @type {((inputs?: Coinvestments_Senddrafts_Unknownlp3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Unknownlp3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_unknownlp3(inputs)
});
export { coinvestments_senddrafts_unknownlp3 as "coInvestments_sendDrafts_unknownLp" }